import { createSlice } from '@reduxjs/toolkit';

const taskViewToggleSlice = createSlice({
  name: 'taskViewToggle',
  initialState: {
    showTaskView: null
  },
  reducers: {
    setShowTaskViewAction: (state, action) => {
      state.showTaskView = action.payload
    }
  }
});

export const { setShowTaskViewAction } = taskViewToggleSlice.actions;
export default taskViewToggleSlice.reducer;

export const getShowTaskViewSelector = (state) => state.taskView.showTaskView;

